import React, { memo, useState } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { JiraPopup } from '@atlassian/jira-popup/src/ui/jira-popup.tsx';
import RoundCreateButton from '../../../../common/ui/round-create-button/index.tsx';
import messages from './messages.tsx';
import OverviewLimitPopup from './overview-limit-popup/index.tsx';

const CREATE_BUTTON_TEST_ID =
	'navigation-apps-sidebar-core.ui.multi-project-menu.overviews.create-overview';

type Props = {
	onClick: () => void;
	hasReachedLimit: boolean;
};

const CreateOverview = ({ onClick, hasReachedLimit }: Props) => {
	const { formatMessage } = useIntl();
	const [isWarningOpen, setIsWarningOpen] = useState(false);

	if (hasReachedLimit) {
		return (
			<JiraPopup
				messageId="navigation-apps-sidebar-core.ui.multi-project-menu.overviews.create-overview.jira-popup"
				messageType="transactional"
				placement="bottom-start"
				isOpen={isWarningOpen}
				onClose={() => setIsWarningOpen(false)}
				trigger={({ ref, ...triggerProps }) => (
					<RoundCreateButton
						{...triggerProps}
						onClick={() => setIsWarningOpen((isOpen) => !isOpen)}
						label={formatMessage(messages.createOverviewLabel)}
						testId={CREATE_BUTTON_TEST_ID}
						ref={ref}
					/>
				)}
				content={() => <OverviewLimitPopup />}
			/>
		);
	}

	return (
		<RoundCreateButton
			onClick={onClick}
			label={formatMessage(messages.createOverviewLabel)}
			testId={CREATE_BUTTON_TEST_ID}
		/>
	);
};

export default memo(CreateOverview);
